import keyby from "lodash.keyby";
import groupby from "lodash.groupby";
import mapvalues from "lodash.mapvalues";

const actualResponse = [
  {
    id: 17843849425012112,
    hashtag: "austin",
    media_count: 8334323
  },
  {
    id: 17841562600099448,
    hashtag: "austinmahone",
    media_count: 1852562
  },
  {
    id: 17843830537003608,
    hashtag: "austintx",
    media_count: 1718961
  },
  {
    id: 17841562825097072,
    hashtag: "austintexas",
    media_count: 794771
  },
  {
    id: 17843887378016144,
    hashtag: "austincarlile",
    media_count: 413361
  },
  {
    id: 17841546091107464,
    hashtag: "austinandally",
    media_count: 413361
  },
  {
    id: 17841563056091674,
    hashtag: "austinphotographer",
    media_count: 175030
  },
  {
    id: 17841506002122020,
    hashtag: "austinmoon",
    media_count: 133570
  },
  {
    id: 17841552172118464,
    hashtag: "austinblogger",
    media_count: 127810
  },
  {
    id: 17843863708041136,
    hashtag: "austineats",
    media_count: 127789
  },
  {
    id: 17841564178087410,
    hashtag: "austinpowers",
    media_count: 118715
  },
  {
    id: 17841563185108476,
    hashtag: "austinart",
    media_count: 103776
  },
  {
    id: 17841562993112044,
    hashtag: "austincitylimits",
    media_count: 102818
  },
  {
    id: 17841512179120662,
    hashtag: "austinlife",
    media_count: 92618
  },
  {
    id: 17841535213116468,
    hashtag: "austinwedding",
    media_count: 87659
  },
  {
    id: 17843760781018240,
    hashtag: "austindogs",
    media_count: 87555
  },
  {
    id: 17841536923126888,
    hashtag: "austinfood",
    media_count: 83984
  },
  {
    id: 17842254745068534,
    hashtag: "austinhair",
    media_count: 82450
  },
  {
    id: 17841596158075834,
    hashtag: "austinmini",
    media_count: 75797
  },
  {
    id: 17841591166076398,
    hashtag: "austinmusic",
    media_count: 74069
  },
  {
    id: 17843689822043020,
    hashtag: "austinbutler",
    media_count: 72693
  },
  {
    id: 17841541039086854,
    hashtag: "austinartist",
    media_count: 72242
  },
  {
    id: 17841509368104606,
    hashtag: "austinmcbroom",
    media_count: 69429
  },
  {
    id: 17841534586129820,
    hashtag: "austinfoodie",
    media_count: 67771
  },
  {
    id: 17841530539129028,
    hashtag: "austin360eats",
    media_count: 67082
  },
  {
    id: 17843743540022490,
    hashtag: "austincartermahone",
    media_count: 63321
  },
  {
    id: 17842132720070824,
    hashtag: "austinhairstylist",
    media_count: 62905
  },
  {
    id: 17843632717049846,
    hashtag: "austinporter",
    media_count: 59127
  },
  {
    id: 17841522652085686,
    hashtag: "austin360",
    media_count: 54515
  },
  {
    id: 17841560761103104,
    hashtag: "austinstyle",
    media_count: 52704
  },
  {
    id: 17841554554111648,
    hashtag: "austinmodel",
    media_count: 51072
  },
  {
    id: 17843435251060828,
    hashtag: "austinandallyseason4",
    media_count: 49303
  },
  {
    id: 17842298083070776,
    hashtag: "austin316",
    media_count: 47906
  },
  {
    id: 17843780731009958,
    hashtag: "austinhealey",
    media_count: 47125
  },
  {
    id: 17841564121101028,
    hashtag: "austinpetsalive",
    media_count: 46648
  },
  {
    id: 17842338505040088,
    hashtag: "austinfitness",
    media_count: 44848
  },
  {
    id: 17842031203070540,
    hashtag: "austinstylist",
    media_count: 43746
  },
  {
    id: 17841508096105730,
    hashtag: "austinrealestate",
    media_count: 43728
  },
  {
    id: 17842297348066200,
    hashtag: "austinphotography",
    media_count: 40166
  },
  {
    id: 17843457445012268,
    hashtag: "austinfoodstagram",
    media_count: 39833
  },
  {
    id: 17843736019028258,
    hashtag: "austinfashion",
    media_count: 39445
  },
  {
    id: 17843782141061782,
    hashtag: "austinfit",
    media_count: 38415
  },
  {
    id: 17843684074052844,
    hashtag: "austinandallymovie",
    media_count: 38091
  },
  {
    id: 17843726029022464,
    hashtag: "austinweddings",
    media_count: 37803
  },
  {
    id: 17841546010093892,
    hashtag: "austinite",
    media_count: 35749
  },
  {
    id: 17843641495063926,
    hashtag: "austinmodels",
    media_count: 33496
  },
  {
    id: 17841562408103620,
    hashtag: "austintattoo",
    media_count: 32617
  },
  {
    id: 17841520960116916,
    hashtag: "austinevents",
    media_count: 31592
  },
  {
    id: 17842064788066534,
    hashtag: "austinliving",
    media_count: 29707
  },
  {
    id: 17843639308036096,
    hashtag: "austinvintage",
    media_count: 28257
  },
  {
    id: 17841522004116352,
    hashtag: "austinmahoneimagine",
    media_count: 27425
  },
  {
    id: 17842188973036184,
    hashtag: "austinmakeupartist",
    media_count: 25925
  },
  {
    id: 17841564295087470,
    hashtag: "austinm",
    media_count: 25413
  },
  {
    id: 17843722012006804,
    hashtag: "austinmua",
    media_count: 23054
  },
  {
    id: 17843829577040240,
    hashtag: "austins",
    media_count: 10281
  }
];
export const defaultResultsByName = keyby(actualResponse, "hashtag");
const groupsByCount = groupby(actualResponse, "media_count");
export const defaultResultsByCount = mapvalues(groupsByCount, group =>
  group.map(result => result.hashtag)
);

export default actualResponse;



// WEBPACK FOOTER //
// ./src/reducers/sampleResults.js